import { lazy, Suspense } from "react";

/**
 * Envoltura diferida de `ProductGallery`.
 *
 * PERF: mantiene `embla-carousel` (~50 kB) fuera del chunk de entrada; el
 * carrusel se descarga al montar la ficha del tour, con un placeholder del
 * mismo tamaño para no mover el layout.
 */
const ProductGalleryImpl = lazy(() =>
  import("./ProductGallery").then((m) => ({ default: m.ProductGallery })),
);

export function ProductGalleryLazy(props: {
  images: string[];
  alt: string;
  singleViewAll?: boolean;
}) {
  return (
    <Suspense
      fallback={<div className="aspect-[16/10] w-full animate-pulse rounded-2xl bg-muted" />}
    >
      <ProductGalleryImpl {...props} />
    </Suspense>
  );
}
